module.exports = __webpack_public_path__ + "img/star-colored-icon.66784395.svg";